import { MainMenu } from "./MainMenu";
import { BackgroundVideo } from "./BackgroundVideo";
import { Slider } from "./Slider";
import { BusinessIntroResizer } from "./BusinessIntroResizer";
import { IframeResizer } from "./IframeResizer";

class BlogParts {
    static attach() {
        const contentBlogParts = document.querySelector("[data-content='blogparts']");
        if (contentBlogParts) {
            MainMenu.attach(contentBlogParts);
            BackgroundVideo.attach(contentBlogParts);
            Slider.attach(contentBlogParts);
            BusinessIntroResizer.attach(contentBlogParts);
            IframeResizer.attach(contentBlogParts);
        }
    }
}

export { BlogParts };
